import styled from 'styled-components';

const InteractDot = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 6px;
	height: 6px;
	background: rgba(255, 255, 255, 0.25);
	border-radius: 6px;
	pointer-events: none;
	border: 1px solid #ffffff;

	transition: opacity 0.3s ease;
	opacity: 0;

	&.interact-enter {
		opacity: 0;
	}

	&.interact-enter-active,
	&.interact-enter-done,
	&.interact-exit {
		opacity: 1;
	}

	&.interact-exit-active {
		opacity: 0;
	}
`;

export { InteractDot };
